export default class UserDisplayableError extends Error {}
